module.exports = __webpack_public_path__ + "img/slide-18-4.caa87f50.jpg";